import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../base/Dialog/Dialog';
import { Button, Icons } from '../base/BootstrapComponents/BootstrapComponents';
import TextInputWithLabel from '../fields/TextInput/TextInputWithLabel';
import FieldDTOWithCol from '../fields/Abstract/FieldDTOWithCol';
import FieldDTO from '../fields/Abstract/FieldDTO';
import { errorNotification, successNotification } from '../../modules/Notifications/notificationDecorator';
import { getResponseError, setFormError } from '../../utils/utils';
import { updatePassword } from '../../modules/Authorized/actions';

export default function EditPassword({ onHide = () => {} }) {
  const dispatch = useDispatch();
  const { control, getValues } = useForm({
    mode: 'onChange',
    defaultValues: {},
  });

  const onSave = () => {
    const values = getValues();
    dispatch(updatePassword(values))
      .then(() => {
        onHide();
        successNotification('Сохранение пароля', 'Новый пароль успешно сохранен');
      })
      .catch(response => {
        errorNotification('Сохранение пароля', getResponseError(response));
      });
  };

  return (
    <Dialog className="edit-password-dialog" onClose={onHide} open>
      <DialogTitle header="Изменение пароля" title={<Icons onClick={onHide} customIcon icon="close" className="close" />} />
      <DialogContent className="hff-content custom-scroll-theme">
        <FieldDTO
          control={control}
          type="text"
          component={TextInputWithLabel}
          dtoObject={
            {
              name: 'current_password',
              type: String,
              labelKey: 'current.password',
            }
          }
          variant="material"
        />
        <FieldDTO
          control={control}
          type="text"
          component={TextInputWithLabel}
          dtoObject={
            {
              name: 'new_password',
              type: String,
              labelKey: 'new.password',
            }
          }
          variant="material"
        />
        <FieldDTO
          control={control}
          type="text"
          component={TextInputWithLabel}
          dtoObject={
            {
              name: 'repeat_password',
              type: String,
              labelKey: 'repeat.password',
            }
          }
          variant="material"
        />
      </DialogContent>
      <DialogFooter>
        <div className="hff-footer-buttons">
          <Button className="hff-clear-show" onClick={onSave}>Сохранить</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
